<template>
    <el-container class="list-page">
        <el-header class="list-page-header centered-list-search-header">
            <h1 class="list-page-title">{{$t('client.pageTitle')}}</h1>
            <div class="list-page-search">
                <el-input prefix-icon="el-icon-search" v-model="searchContent"
                          :disabled="!contextLoaded"
                          :placeholder="$t('client.searchPlaceholder')"></el-input>
            </div>
            <div class="list-page-header-actions">
                <el-button class="list-page-export-button" :loading="exporting" :disabled="!contextLoaded || loading" @click="exportData">
                    <i class="el-icon-download"></i>
                    <span>{{$t('report.export')}}</span>
                </el-button>
                <el-button class="list-page-add-button" type="primary" :disabled="!contextLoaded || loading"
                           @click.native.prevent="goAddClient">
                    <i class="el-icon-plus"></i>
                    <span>{{$t('client.addClient')}}</span>
                </el-button>
            </div>
        </el-header>
        <el-main class="list-page-main" v-loading="loading">
            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <template v-else-if="contextLoaded">
                <list-batch-actions :selected-count="selectedRows.length" :actions="batchActions"
                                    :loading-action="batchLoadingAction" @action="handleBatchAction"></list-batch-actions>
                <div class="list-table-card client-desktop-table">
                    <el-table ref="listTable" class="list-table" @sort-change="sortTable" :data="tableData"
                              :empty-text="$t('common.noData')"
                              row-key="innerUUID" @selection-change="handleSelectionChange"
                              @select-all="handleSelectAll" @row-click='handleRowHandle'>
                        <el-table-column type="selection" width="52" :reserve-selection="true"></el-table-column>
                        <el-table-column prop="name" :label="$t('client.columnClientName')" sortable="custom" :sort-orders="['descending', 'ascending']" min-width="180">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'name'}">
                                    {{$t('client.columnClientName')}}
                                    <svg v-if="orderName === 'name'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'name' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                            <template slot-scope="scope">
                                <span>{{scope.row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="clientEmail" :label="$t('client.columnEmail')" min-width="220">
                            <template slot-scope="scope">
                                <span>{{scope.row.clientEmail}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" :label="$t('client.columnPhone')" min-width="160">
                            <template slot-scope="scope">
                                <span>{{scope.row.phone}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalBalanceDue" :formatter="amountFormat" :label="$t('client.columnBalanceDue')"
                                         sortable="custom" :sort-orders="['descending', 'ascending']"
                                         min-width="160" align="right" header-align="right">
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="tableData.length === 0" class="client-mobile-empty">{{$t('common.noData')}}</div>
                <div v-else class="client-mobile-list">
                    <article v-for="client in tableData" :key="client.innerUUID" class="client-mobile-card"
                             role="button" tabindex="0" @click="openClient(client, $event)" @keyup.enter.self="openClient(client)"
                             @keyup.space.self.prevent="openClient(client)">
                        <el-checkbox class="client-mobile-checkbox" :value="isRowSelected(client)"
                                     :aria-label="$t('client.columnClientName')"
                                     @click.native.stop @change="toggleMobileSelection(client, $event)"></el-checkbox>
                        <div class="client-mobile-content">
                            <div class="client-mobile-heading">
                                <strong>{{client.name}}</strong>
                                <strong>{{amountFormat(client, {property: 'totalBalanceDue'})}}</strong>
                            </div>
                            <div class="client-mobile-facts">
                                <span><small>{{$t('client.columnEmail')}}</small>{{client.clientEmail}}</span>
                                <span><small>{{$t('client.columnPhone')}}</small>{{client.phone}}</span>
                            </div>
                        </div>
                    </article>
                </div>
                    <!--<el-table-column label="">
                        <template slot-scope="scope">
                            <el-button size="mini" @click.stop="handleClick(scope.$index, scope.row)">statement</el-button>
                        </template>
                    </el-table-column>-->
                <div class="list-pagination">
                    <el-pagination
                            :key="'client-pagination-' + currentPage + '-' + pageSize"
                            @size-change="changeTotalCount"
                            @current-change="changePage"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                    </el-pagination>
                </div>
            </template>


        </el-main>
    </el-container>
</template>

<script>
    import {debounce} from '@/utils/debounce'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {readListPagination, writeListPagination} from '@/utils/listPagination'
    import {readListQueryState, writeListQueryState} from '@/utils/listQueryState'
    import {syncCompanySelection} from '@/utils/company'
    import {downloadDataExport} from '@/utils/dataExport'
    import {openListDetail} from '@/utils/listNavigation'
    import ListBatchActions from '@/components/common/ListBatchActions'

    export default {
        components: {
            ListBatchActions
        },
        computed: {
            batchActions() {
                return [
                    {key: 'delete', label: this.$t('common.delete'), icon: 'el-icon-delete', danger: true}
                ];
            }
        },
        methods: {
            buildListParams() {
                if (this.company == null) {
                    throw new Error('Current company is required');
                }
                return {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    userWebCommonQuery: this.searchContent,
                    orderName: this.orderName,
                    orderTpe: this.orderTpe,
                    delStatus: 0,
                    companyUUID: this.company.innerUUID
                };
            },
            exportData() {
                if (!this.contextLoaded || this.loading || this.exporting) {
                    return;
                }
                this.exporting = true;
                return downloadDataExport(this.$axios, 'CLIENT', this.buildListParams()).catch(() => {
                    this.$message.error(this.$t('common.systemError'));
                }).finally(() => {
                    this.exporting = false;
                });
            },
            handleSelectionChange(selection) {
                this.selectedRows = selection;
            },
            handleSelectAll(selection) {
                const selectedUUIDSet = new Set(selection.map(row => row.innerUUID));
                const allCurrentPageSelected = this.tableData.length > 0
                    && this.tableData.every(row => selectedUUIDSet.has(row.innerUUID));
                if (!allCurrentPageSelected) {
                    this.clearSelection();
                }
            },
            isRowSelected(row) {
                return this.selectedRows.some(selected => selected.innerUUID === row.innerUUID);
            },
            toggleMobileSelection(row, selected) {
                if (this.$refs.listTable) {
                    this.$refs.listTable.toggleRowSelection(row, selected);
                }
            },
            clearSelection() {
                this.selectedRows = [];
                if (this.$refs.listTable) {
                    this.$refs.listTable.clearSelection();
                }
            },
            handleBatchAction() {
                this.$confirm(this.$t('common.batchDeleteConfirm', {count: this.selectedRows.length}), this.$t('common.warning'), {
                    confirmButtonText: this.$t('common.ok'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                }).then(() => this.deleteSelectedClients()).catch(() => {});
            },
            deleteSelectedClients() {
                if (!this.contextLoaded || this.company == null || this.batchLoadingAction !== '') {
                    return;
                }
                this.batchLoadingAction = 'delete';
                return this.$axios.post('web_batch_action', {
                    params: {
                        entityType: 'CLIENT',
                        action: 'DELETE',
                        companyUUID: this.company.innerUUID,
                        innerUUIDList: this.selectedRows.map(row => row.innerUUID)
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        this.$message.success(this.$t('common.batchActionSuccess', {count: response.data.processedCount}));
                        this.moveToExistingPage(response.data.processedCount);
                        this.clearSelection();
                        this.queryList();
                    }
                }).finally(() => {
                    this.batchLoadingAction = '';
                });
            },
            moveToExistingPage(deletedCount) {
                const remainingCount = Math.max(0, this.totalCount - deletedCount);
                const lastPage = Math.max(1, Math.ceil(remainingCount / this.pageSize));
                if (this.currentPage > lastPage) {
                    this.currentPage = lastPage;
                    this.saveListPagination();
                }
            },
            restoreListPagination() {
                const pagination = readListPagination('client');
                if (pagination != null) {
                    this.currentPage = pagination.currentPage;
                    this.pageSize = pagination.pageSize;
                }
            },
            restoreListQueryState() {
                const queryState = readListQueryState('client');
                if (queryState == null) {
                    return;
                }
                this.currentPage = queryState.currentPage;
                this.pageSize = queryState.pageSize;
                this.searchContent = queryState.searchContent;
                this.orderName = queryState.orderName;
                this.orderTpe = queryState.orderTpe;
            },
            saveListQueryState() {
                writeListQueryState('client', {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    searchContent: this.searchContent,
                    orderName: this.orderName,
                    orderTpe: this.orderTpe
                });
            },
            saveListPagination() {
                writeListPagination('client', this.currentPage, this.pageSize);
            },
            goAddClient() {
                if (!this.contextLoaded || this.loading) {
                    return;
                }
                this.$router.push('/clientCreate');
            },
            queryList() {
                if (!this.contextLoaded || this.company == null) {
                    return Promise.reject(new Error('Current company is required'));
                }
                const requestSequence = ++this.listRequestSequence;
                this.loading = true;
                this.loadError = "";
                let that = this;
                return this.$axios.post('query_user_client_user_web', {
                    params: this.buildListParams()
                }).then(response => {
                    if (requestSequence !== that.listRequestSequence) {
                        return;
                    }
                    if (response.data.errorCode !== 0) {
                        throw new Error('Client list query failed');
                    }
                    const clientUUIDSet = new Set();
                    const dataList = Array.isArray(response.data.dataList) ? response.data.dataList : [];
                    that.tableData = dataList.filter(client => {
                        if (client == null
                            || (client.innerUUID != null && clientUUIDSet.has(client.innerUUID))
                            || (client.companyUUID != null && client.companyUUID !== that.company.innerUUID)
                            || Number(client.isDelete) === 1) {
                            return false;
                        }
                        if (client.innerUUID != null && client.innerUUID !== '') {
                            clientUUIDSet.add(client.innerUUID);
                        }
                        return true;
                    });
                    const totalCount = Number(response.data.totalCount);
                    that.totalCount = Number.isFinite(totalCount) && totalCount >= 0
                        ? Math.floor(totalCount) : that.tableData.length;
                    that.loading = false;
                }).catch(() => {
                    if (requestSequence === that.listRequestSequence) {
                        that.loading = false;
                        that.loadError = that.$t('common.loadFailed');
                    }
                })
            },
            sortTable(column) {
                if (!this.contextLoaded || this.loading) {
                    return;
                }
                this.clearSelection();
                if (!column.order) {
                    this.orderName = "";
                    this.orderTpe = "";
                    this.queryList();
                    return;
                }
                this.orderName = column.prop;
                if (column.order === "ascending") {
                    this.orderTpe = 1
                } else if (column.order === "descending") {
                    this.orderTpe = 2
                }
                this.queryList();
            },
            changePage(val) {
                if (!this.contextLoaded || this.loading) {
                    return;
                }
                this.currentPage = val;
                this.saveListPagination();
                this.queryList();
            },
            changeTotalCount(val) {
                if (!this.contextLoaded || this.loading) {
                    return;
                }
                this.currentPage = 1;
                this.pageSize = val;
                this.saveListPagination();
                this.queryList();
            },
            handleRowHandle(row, column, event) {
                if (!this.contextLoaded || this.loading) {
                    return false;
                }
                //点击每一条列表数据触发的方法
                if (column && column.type === "selection") {
                    return false;
                }
                this.openClient(row, event);
            },
            openClient(row, event) {
                if (!this.contextLoaded || this.loading) {
                    return;
                }
                openListDetail(this.$router, {path: 'clientUpdate', query: {innerUUID: row.innerUUID}}, event);
            },
            amountFormat: function (row, column) {
                return xiaoshudianfenge(row[column.property], this.userSetting);
            },
        },
        data() {
            return {
                tableData: [],
                loading: true,
                loadError: "",
                listRequestSequence: 0,
                contextLoaded: false,
                company: null,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                searchContent: "",
                selectedRows: [],
                batchLoadingAction: '',
                exporting: false,
                orderName: "createDate",
                orderTpe: 2,
                userSetting: null
            }
        },
        async mounted() {
            this.restoreListPagination();
            try {
                const response = await this.$axios.post('query_setting_and_company', {params: {}});
                if (response.data.errorCode !== 0) {
                    throw new Error('Company and setting query failed');
                }
                const selectedData = syncCompanySelection(response.data);
                if (selectedData == null) {
                    throw new Error('Selected company data is missing');
                }
                this.company = selectedData.company;
                this.userSetting = selectedData.setting;
                this.restoreListQueryState();
                this.contextLoaded = true;
                await this.queryList();
            } catch {
                this.loading = false;
                this.loadError = this.$t('common.loadFailed');
            }
            this.$watch('searchContent', debounce(() => {
                if (!this.contextLoaded) {
                    return;
                }
                this.clearSelection();
                this.currentPage = 1;
                this.saveListPagination();
                this.queryList();
            }, 500));
        },
        beforeRouteLeave(to, from, next) {
            this.saveListQueryState();
            next();
        }
    }
</script>
<style scoped>
    .client-mobile-list, .client-mobile-empty { display: none; }
    @media (max-width: 720px) {
        .client-desktop-table { display: none; }
        .client-mobile-list { display: grid; gap: 12px; }
        .client-mobile-empty {
            display: block; padding: 42px 16px; border: 1px dashed #d8dee8; border-radius: 14px;
            background: #fff; color: #8a97aa; text-align: center;
        }
        .client-mobile-card {
            display: grid; grid-template-columns: auto minmax(0, 1fr); gap: 14px; padding: 16px;
            border: 1px solid #e6eaf0; border-radius: 14px; background: #fff; color: #263653;
            box-shadow: 0 6px 18px rgba(42, 61, 92, .06); cursor: pointer;
        }
        .client-mobile-card:focus-visible { outline: 3px solid rgba(64, 158, 255, .28); outline-offset: 2px; }
        .client-mobile-checkbox { padding-top: 2px; }
        .client-mobile-content { min-width: 0; }
        .client-mobile-heading { display: flex; justify-content: space-between; gap: 14px; }
        .client-mobile-heading strong { min-width: 0; overflow-wrap: anywhere; }
        .client-mobile-heading strong:first-child {
            display: -webkit-box; overflow: hidden; -webkit-box-orient: vertical; -webkit-line-clamp: 3;
        }
        .client-mobile-heading strong:last-child { flex: none; font-variant-numeric: tabular-nums; }
        .client-mobile-facts { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-top: 14px; }
        .client-mobile-facts span { min-width: 0; overflow-wrap: anywhere; }
        .client-mobile-facts small { display: block; margin-bottom: 4px; color: #8a97aa; font-size: 11px; font-weight: 700; text-transform: uppercase; }
    }
    @media (max-width: 430px) {
        .client-mobile-facts { grid-template-columns: minmax(0, 1fr); }
    }
</style>
